(() => {
  if (window.DislejCartDrawerFixed) return;
  window.DislejCartDrawerFixed = true;

  document.documentElement.classList.add('dislej-custom-cart-enabled');

  const root =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  const buildRoute = (path) => `${root}${path.replace(/^\//, '')}`;

  const routes = {
    add: buildRoute('/cart/add.js'),
    cart: buildRoute('/cart.js'),
    change: buildRoute('/cart/change.js'),
    checkout: buildRoute('/checkout')
  };

  const selectors = {
    drawer: '[data-dislej-cart-drawer]',
    panel: '.dislej-cart-drawer__panel',
    close: '[data-dislej-cart-close]',
    items: '[data-dislej-cart-items]',
    empty: '[data-dislej-cart-empty]',
    footer: '[data-dislej-cart-footer]',
    subtotal: '[data-dislej-cart-subtotal]',
    countText: '[data-dislej-cart-count-text]',
    shippingWrap: '[data-dislej-shipping-wrap]',
    shippingText: '[data-dislej-shipping-text]',
    shippingFill: '[data-dislej-shipping-fill]',
    checkoutLink: '[data-dislej-checkout-link]',
    upsellWrap: '[data-dislej-cart-upsell]',
    upsellRows: '[data-dislej-cart-upsell-rows]'
  };

  const drawer = document.querySelector(selectors.drawer);
  if (!drawer) return;

  const removeLabel = drawer.dataset.removeLabel || 'Remove';

  const panel = drawer.querySelector(selectors.panel);
  const itemsContainer = drawer.querySelector(selectors.items);
  const emptyState = drawer.querySelector(selectors.empty);
  const footer = drawer.querySelector(selectors.footer);
  const subtotalEl = drawer.querySelector(selectors.subtotal);
  const countText = drawer.querySelector(selectors.countText);
  const shippingWrap = drawer.querySelector(selectors.shippingWrap);
  const shippingText = drawer.querySelector(selectors.shippingText);
  const shippingFill = drawer.querySelector(selectors.shippingFill);
  const checkoutLink = drawer.querySelector(selectors.checkoutLink);
  const upsellWrap = drawer.querySelector(selectors.upsellWrap);
  const upsellRows = drawer.querySelector(selectors.upsellRows);

  let upsellPool = [];
  try {
    const poolEl = document.getElementById('dislej-upsell-pool');
    if (poolEl) upsellPool = JSON.parse(poolEl.textContent) || [];
  } catch (error) {
    upsellPool = [];
  }

  // Color words stripped from a title to get its "base name" — used to
  // detect variants of the same product (e.g. "Bluza ... czarna" / "... brązowa").
  const COLOR_WORDS = [
    'czarny', 'czarna', 'czarne', 'czerń',
    'biały', 'biała', 'białe', 'biel',
    'beżowy', 'beżowa', 'beżowe',
    'brązowy', 'brązowa', 'brązowe', 'khaki',
    'szary', 'szara', 'szare',
    'różowy', 'różowa', 'różowe',
    'czerwony', 'czerwona', 'czerwone', 'bordowy', 'bordowa',
    'niebieski', 'niebieska', 'niebieskie', 'błękitny', 'błękitna', 'jeansowy', 'jeans',
    'żółty', 'żółta', 'żółte', 'złoty', 'złota',
    'zielony', 'zielona', 'zielone',
    'ecru', 'wielokolorowy', 'wielokolorowa'
  ];
  const COLOR_WORDS_RE = new RegExp('\\b(' + COLOR_WORDS.join('|') + ')\\b', 'gi');

  const baseName = (title) =>
    (title || '')
      .replace(COLOR_WORDS_RE, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

  // Polish plural rules for "przedmiot": 1 → przedmiot; 2-4 (excluding
  // 12-14) → przedmioty; everything else (0, 5+, 12-14) → przedmiotów.
  const polishItemNoun = (count) => {
    const n = Math.abs(count);
    const lastDigit = n % 10;
    const lastTwoDigits = n % 100;

    if (n === 1) return 'przedmiot';
    if (
      lastDigit >= 2 &&
      lastDigit <= 4 &&
      !(lastTwoDigits >= 12 && lastTwoDigits <= 14)
    ) {
      return 'przedmioty';
    }
    return 'przedmiotów';
  };

  // Mirrors the category→target-categories map used by POŁĄCZ Z on the
  // product page (sections/main-product.liquid) — kept in sync by hand so
  // the cart upsell can prefer items that would actually show up there.
  const POLACZ_Z_CATEGORY_MAP = {
    'Sukienki': ['Żakiety', 'Torebki', 'Swetry'],
    'Spodnie': ['Bluzki', 'Topy', 'Body', 'Koszule'],
    'Spódnice': ['Bluzki', 'Topy', 'Body', 'Swetry'],
    'Spodenki': ['Topy', 'Bluzki', 'T-shirty'],
    'Żakiety': ['Sukienki', 'Spodnie', 'Topy'],
    'Kurtki': ['Sukienki', 'Spodnie', 'Swetry'],
    'Płaszcze': ['Sukienki', 'Spodnie', 'Swetry'],
    'Bluzki': ['Spodnie', 'Spódnice', 'Spodenki'],
    'Koszule': ['Spodnie', 'Spódnice', 'Spodenki'],
    'Topy': ['Spodnie', 'Spódnice', 'Spodenki'],
    'Body': ['Spodnie', 'Spódnice', 'Spodenki'],
    'T-shirty': ['Spodnie', 'Spódnice', 'Spodenki'],
    'Swetry': ['Spodnie', 'Spódnice', 'Sukienki'],
    'bluzy': ['Spodnie', 'Spódnice', 'Sukienki'],
    'Komplety': ['Torebki', 'Body', 'Topy'],
    'Garnitury': ['Torebki', 'Body', 'Topy'],
    'Torebki': ['Sukienki', 'Komplety']
  };

  const threshold = Number(drawer.dataset.freeShippingThreshold || 0);
  const progressMessage = drawer.dataset.freeShippingMessage || 'Spend [amount] more for free shipping';
  const successMessage = drawer.dataset.freeShippingSuccess || 'You have unlocked free shipping';

  if (checkoutLink) {
    checkoutLink.setAttribute('href', routes.checkout);
  }

  const escapeHTML = (value) => {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  };

  const formatMoney = (cents, currency) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    const amount = Number(cents || 0) / 100;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency || 'USD'
      }).format(amount);
    } catch (error) {
      return amount.toFixed(2);
    }
  };

  const getImageSrc = (src, width = 220) => {
    if (!src) return '';
    return `${src}${src.includes('?') ? '&' : '?'}width=${width}`;
  };

  const closeNativeCart = () => {
    document.querySelectorAll('cart-drawer, cart-notification').forEach((element) => {
      if (typeof element.close === 'function') {
        element.close();
      }

      element.classList.remove('active', 'animate');
      element.setAttribute('aria-hidden', 'true');
    });

    document.body.classList.remove('overflow-hidden');
  };

  const openDrawer = () => {
    closeNativeCart();

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dislej-cart-is-open');

    setTimeout(() => {
      if (panel) panel.focus();
    }, 60);
  };

  const closeDrawer = () => {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dislej-cart-is-open');
  };

  const fetchCart = async () => {
    const response = await fetch(routes.cart, {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Cart load failed.');
    }

    return response.json();
  };

  const addToCart = async (form, submitter) => {
    const formData = new FormData(form);

    if (submitter && submitter.name) {
      formData.append(submitter.name, submitter.value);
    }

    formData.delete('sections');
    formData.delete('sections_url');

    const response = await fetch(routes.add, {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: formData
    });

    const data = await response.json();

    if (!response.ok) {
      const message =
        data && data.description
          ? data.description
          : data && data.message
            ? data.message
            : 'Unable to add this product to cart.';

      throw new Error(message);
    }

    return data;
  };

  const changeCartLine = async (line, quantity) => {
    const response = await fetch(routes.change, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        line,
        quantity
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error('Unable to update cart.');
    }

    return data;
  };

  const updateCartBubble = (cart) => {
    const count = cart.item_count || 0;

    document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
      bubble.style.display = count > 0 ? '' : 'none';

      const spans = bubble.querySelectorAll('span');

      if (spans.length) {
        spans.forEach((span) => {
          span.textContent = count;
        });
      } else {
        bubble.textContent = count;
      }
    });

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
    });
  };

  const renderShippingProgress = (cart) => {
    if (!shippingWrap || !shippingText || !shippingFill || !threshold) return;

    if (!cart.item_count) {
      shippingWrap.hidden = true;
      shippingFill.style.width = '0%';
      return;
    }

    shippingWrap.hidden = false;

    const total = cart.total_price || 0;
    const remaining = threshold - total;
    const percent = Math.min(100, Math.max(0, (total / threshold) * 100));

    shippingFill.style.width = `${percent}%`;

    if (remaining > 0) {
      shippingText.textContent = progressMessage.replace('[amount]', formatMoney(remaining, cart.currency));
    } else {
      shippingText.textContent = successMessage;
    }
  };

  const renderUpsell = (cart) => {
    if (!upsellWrap || !upsellRows) return;

    if (!cart.item_count || !upsellPool.length) {
      upsellWrap.hidden = true;
      upsellRows.innerHTML = '';
      return;
    }

    const cartBaseNames = new Set(cart.items.map((item) => baseName(item.product_title)));
    const cartProductIds = new Set(cart.items.map((item) => item.product_id));
    const priceCeiling = 13000; // 130 zł flat cap (bags are exempt below)

    // What POŁĄCZ Z would show for what's already in the cart: exact
    // manual pairs (custom.polacz_z) set on the cart's own products, plus
    // the same category map POŁĄCZ Z falls back to when there's no manual
    // pairing. Cross-referencing this is how the clothing half of the
    // upsell is picked below.
    const manualCrossRefIds = new Set();
    upsellPool.forEach((product) => {
      if (cartProductIds.has(product.id) && Array.isArray(product.polaczZ)) {
        product.polaczZ.forEach((id) => manualCrossRefIds.add(id));
      }
    });

    const cartTargetCategories = new Set();
    cart.items.forEach((item) => {
      const targets = POLACZ_Z_CATEGORY_MAP[item.product_type];
      if (targets) targets.forEach((type) => cartTargetCategories.add(type));
    });

    // Bags are the canonical "add one more thing" accessory here and are
    // never priced under a small cart's ceiling — exempt them from the
    // price rule so they can actually appear; everything else must qualify.
    const candidates = upsellPool.filter((product) => {
      if (cartProductIds.has(product.id)) return false;
      if (cartBaseNames.has(baseName(product.title))) return false;
      const isBag = product.productType === 'Torebki';
      if (!isBag && product.price >= priceCeiling) return false;
      return true;
    });

    // Two similarly-titled products (e.g. two bags differing only in
    // strap/closure wording) read as "the same item shown twice" to a
    // customer — dedupe by the first 3 words of the title, not just exact
    // color-stripped match, and keep only the cheapest of each group.
    const titlePrefix = (title) =>
      (title || '').trim().toLowerCase().split(/\s+/).slice(0, 3).join(' ');

    const seenPrefixes = new Set();
    const dedupedCandidates = candidates
      .slice()
      .sort((a, b) => a.price - b.price)
      .filter((product) => {
        const prefix = titlePrefix(product.title);
        if (seenPrefixes.has(prefix)) return false;
        seenPrefixes.add(prefix);
        return true;
      });

    const bagCandidates = dedupedCandidates
      .filter((product) => product.productType === 'Torebki')
      .sort((a, b) => a.price - b.price);

    // Clothing half: prefer an exact POŁĄCZ Z manual pair, then anything
    // in the algorithmic target-category set, then just cheapest-first.
    const clothingCandidates = dedupedCandidates
      .filter((product) => product.productType !== 'Torebki')
      .sort((a, b) => {
        const aManual = manualCrossRefIds.has(a.id) ? 0 : 1;
        const bManual = manualCrossRefIds.has(b.id) ? 0 : 1;
        if (aManual !== bManual) return aManual - bManual;
        const aTarget = cartTargetCategories.has(a.productType) ? 0 : 1;
        const bTarget = cartTargetCategories.has(b.productType) ? 0 : 1;
        if (aTarget !== bTarget) return aTarget - bTarget;
        return a.price - b.price;
      });

    // Up to 4 tiles. The rail is a horizontal-scroll row (fixed height,
    // overflow-x:auto), not a vertical stack, so more tiles only extend
    // scroll width — they never push KUP TERAZ down or cover the cart's
    // own item list. One bag (the canonical accessory upsell here) + up
    // to three cross-referenced clothing picks, each falling back to the
    // other pool if empty.
    // Dislej 21.10.2026 (KOSZ-1): lista 2 wierszy zamiast karuzeli.
    const UPSELL_TILE_COUNT = 2;
    const picked = [];
    if (bagCandidates[0]) picked.push(bagCandidates[0]);
    clothingCandidates.forEach((product) => {
      if (picked.length < UPSELL_TILE_COUNT && !picked.includes(product)) picked.push(product);
    });

    if (picked.length < UPSELL_TILE_COUNT) {
      const fallbackPool = dedupedCandidates.filter((product) => !picked.includes(product));
      while (picked.length < UPSELL_TILE_COUNT && fallbackPool.length) {
        picked.push(fallbackPool.shift());
      }
    }

    if (picked.length < 1) {
      upsellWrap.hidden = true;
      upsellRows.innerHTML = '';
      return;
    }

    upsellWrap.hidden = false;
    upsellRows.innerHTML = picked
      .map(
        (product) => `
          <div class="dislej-cart-drawer__upsell-row">
            <a href="${escapeHTML(product.url)}" class="dislej-cart-drawer__upsell-link" aria-label="${escapeHTML(product.title)}">
              <span class="dislej-cart-drawer__upsell-thumb">
                ${product.image ? `<img src="${escapeHTML(product.image)}" alt="${escapeHTML(product.title)}" loading="lazy" width="52" height="66">` : ''}
              </span>
              <span class="dislej-cart-drawer__upsell-info">
                <span class="dislej-cart-drawer__upsell-name">${escapeHTML(product.title)}</span>
                <span class="dislej-cart-drawer__upsell-price">${formatMoney(product.price, cart.currency)}</span>
              </span>
            </a>
            <form action="${routes.add}" method="post" class="dislej-cart-drawer__upsell-form" data-dislej-ajax-cart>
              <input type="hidden" name="id" value="${escapeHTML(product.variantId)}">
              <button type="submit" class="dislej-cart-drawer__upsell-add" aria-label="Dodaj ${escapeHTML(product.title)} do koszyka">+ Dodaj</button>
            </form>
          </div>
        `
      )
      .join('');
  };

  // Dislej 21.10.2026 (KOSZ-1): podsumowanie nad KUP TERAZ, rabaty z danych koszyka (bez nazw na sztywno).
  const renderPodsum = (cart) => {
    const box = drawer.querySelector('[data-dislej-podsum]');
    if (!box) return;
    const wartosc = box.querySelector('[data-p-wartosc]');
    const rabatyEl = box.querySelector('[data-p-rabaty]');
    const suma = box.querySelector('[data-p-suma]');
    const rabaty = [];
    const dodaj = (tytul, kwota) => {
      if (!kwota) return;
      const r = rabaty.find((x) => x.tytul === tytul);
      if (r) r.kwota += kwota; else rabaty.push({ tytul, kwota });
    };
    (cart.items || []).forEach((item) => {
      (item.line_level_discount_allocations || []).forEach((a) => {
        dodaj((a.discount_application && a.discount_application.title) || 'Rabat', Number(a.amount) || 0);
      });
    });
    (cart.cart_level_discount_applications || []).forEach((d) => dodaj(d.title || 'Rabat', Number(d.total_allocated_amount) || 0));
    if (wartosc) wartosc.textContent = formatMoney(cart.original_total_price, cart.currency);
    if (suma) suma.textContent = formatMoney(cart.total_price, cart.currency);
    if (rabatyEl) {
      rabatyEl.innerHTML = rabaty
        .map((r) => `<div class="dislej-cart-drawer__p-wiersz dislej-cart-drawer__p-rabat"><span>Rabat: ${escapeHTML(r.tytul)}</span><span>−${formatMoney(r.kwota, cart.currency)}</span></div>`)
        .join('');
    }
  };

  const renderCart = (cart) => {
    updateCartBubble(cart);
    renderPodsum(cart);
    renderShippingProgress(cart);
    renderUpsell(cart);

    const itemCount = cart.item_count || 0;

    if (countText) {
      countText.textContent = `(${itemCount})`;
    }

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price, cart.currency);
    }

    if (!itemCount) {
      if (emptyState) emptyState.hidden = false;
      if (footer) footer.hidden = true;
      if (itemsContainer) itemsContainer.innerHTML = '';
      return;
    }

    if (emptyState) emptyState.hidden = true;
    if (footer) footer.hidden = false;

    if (!itemsContainer) return;

    itemsContainer.innerHTML = cart.items
      .map((item, index) => {
        const line = index + 1;
        const imageSrc = getImageSrc(item.image, 220);

        const image = imageSrc
          ? `<img class="dislej-cart-item__image" src="${escapeHTML(imageSrc)}" alt="${escapeHTML(item.product_title)}" loading="lazy">`
          : `<div class="dislej-cart-item__image"></div>`;

        const variantTitle =
          item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="dislej-cart-item__variant">${escapeHTML(item.variant_title)}</p>`
            : '';

        let properties = '';

        if (item.properties) {
          Object.keys(item.properties).forEach((key) => {
            if (key.charAt(0) === '_' || !item.properties[key]) return;
            properties += `<p class="dislej-cart-item__variant">${escapeHTML(key)}: ${escapeHTML(item.properties[key])}</p>`;
          });
        }

        return `
          <div class="dislej-cart-item" data-line="${line}">
            <a href="${escapeHTML(item.url)}" aria-label="${escapeHTML(item.product_title)}">
              ${image}
            </a>

            <div class="dislej-cart-item__info">
              <a class="dislej-cart-item__title" href="${escapeHTML(item.url)}">
                ${escapeHTML(item.product_title)}
              </a>

              ${variantTitle}
              ${properties}

              <div class="dislej-cart-item__bottom">
                <div class="dislej-cart-item__qty">
                  <button type="button" data-dislej-qty-minus aria-label="Zmniejsz ilość">−</button>
                  <input type="text" value="${item.quantity}" aria-label="Ilość" readonly>
                  <button type="button" data-dislej-qty-plus aria-label="Zwiększ ilość">+</button>
                </div>

                <div class="dislej-cart-item__price">
                  ${formatMoney(item.final_line_price, cart.currency)}
                </div>
              </div>

              <button type="button" class="dislej-cart-item__remove" data-dislej-remove  aria-label="${escapeHTML(removeLabel)}">
                 ${escapeHTML(removeLabel)}
              </button>
            </div>
          </div>
        `;
      })
      .join('');
  };

  const refreshCart = async (shouldOpen = false) => {
    const cart = await fetchCart();
    renderCart(cart);

    if (shouldOpen) {
      openDrawer();
    }

    return cart;
  };

  const isCartAddForm = (form) => {
    if (!form) return false;

    const action = form.getAttribute('action') || '';

    return (
      form.hasAttribute('data-dislej-ajax-cart') ||
      action.includes('/cart/add') ||
      action.includes('cart/add')
    );
  };

  const isCartIconLink = (link) => {
    if (!link) return false;

    if (link.closest('[data-dislej-view-cart]')) return false;

    const href = link.getAttribute('href');

    if (!href || href === '#' || href.includes('/checkout')) return false;
    if (href.includes('/cart/add') || href.includes('/cart/change') || href.includes('/cart/update')) return false;

    try {
      const url = new URL(href, window.location.origin);
      const pathname = url.pathname.replace(/\/$/, '');

      return pathname === '/cart' || pathname.endsWith('/cart');
    } catch (error) {
      return href === '/cart' || href.endsWith('/cart');
    }
  };

  document.addEventListener(
    'click',
    async (event) => {
      const cartLink = event.target.closest('a');

      if (!isCartIconLink(cartLink)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      try {
        await refreshCart(true);
      } catch (error) {
        openDrawer();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target.closest('form');

      if (!isCartAddForm(form)) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const submitButton =
        event.submitter ||
        form.querySelector('[type="submit"]') ||
        form.querySelector('button');

      try {
        if (submitButton) {
          submitButton.classList.add('is-loading');
          submitButton.setAttribute('aria-busy', 'true');
          submitButton.disabled = true;
        }

        await addToCart(form, submitButton);
        await refreshCart(true);
      } catch (error) {
        alert(error.message);
      } finally {
        if (submitButton) {
          submitButton.classList.remove('is-loading');
          submitButton.removeAttribute('aria-busy');
          submitButton.disabled = false;
        }
      }
    },
    true
  );

  drawer.addEventListener('click', async (event) => {
    if (event.target.closest(selectors.close)) {
      closeDrawer();
      return;
    }

    const item = event.target.closest('.dislej-cart-item');
    if (!item) return;

    const line = Number(item.dataset.line);
    const input = item.querySelector('input');
    const currentQty = Number(input && input.value ? input.value : 1);

    try {
      if (event.target.closest('[data-dislej-qty-minus]')) {
        await changeCartLine(line, Math.max(0, currentQty - 1));
        await refreshCart(false);
      }

      if (event.target.closest('[data-dislej-qty-plus]')) {
        await changeCartLine(line, currentQty + 1);
        await refreshCart(false);
      }

      if (event.target.closest('[data-dislej-remove]')) {
        await changeCartLine(line, 0);
        await refreshCart(false);
      }
    } catch (error) {
      alert(error.message);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  window.DislejCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshCart
  };

  refreshCart(false).catch(() => {});
})();